/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';
import {getUserByToken, register} from '../core/_requests';
import {Link} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../../_metronic/helpers';
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components';
import {useAuth} from '../core/Auth';
import {Modal} from 'react-bootstrap';
import _ from 'lodash';
import {useIntl} from 'react-intl';

const initialValues = {
  name: '',
  id: '',
  adminEmail: '',
  passWord: '',
  phoneNumber: '',
  changepassword: '',
  address: '',
  userName: '',
};
const regularDomain = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*$/;
const regularPhone = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
const regularExpressionPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,18}$/;
const registrationSchema = Yup.object().shape({
  name: Yup.string().required('Vui lòng nhập họ tên!'),
  id: Yup.string()
    .min(3, 'Tên miền tối thiểu 3 ký tự!')
    .matches(regularDomain, 'Tên miền không hợp lệ!')
    .required('Vui lòng nhập tên miền!'),
  userName: Yup.string()
    .min(3, 'Tên miền tối thiểu 3 ký tự!')
    .matches(regularDomain, 'Tên đăng nhập không hợp lệ!')
    .required('Vui lòng nhập tên miền!'),
  phoneNumber: Yup.string()
    .matches(regularPhone, 'Số điện thoại không hợp lệ!')
    .required('Không hợp lệ'),
  adminEmail: Yup.string().email('Email không đúng định dạng!').required('Vui lòng nhập email!'),
  passWord: Yup.string()
    .matches(
      regularExpressionPassword,
      'Mật khẩu từ 6-18 ký tự, phải có: chữ hoa, chữ thường và các ký tự đặc biệt!'
    )
    .min(6, 'Mật khẩu tối thiểu 6 ký tự!')
    .max(18, 'Mật khẩu tối đa 18 ký tự!')
    .required('Không hợp lệ!'),
  changepassword: Yup.string()
    .required('Không hợp lệ!')
    .when('passWord', {
      is: (val) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('passWord')], 'Mật khẩu không khớp!'),
    }),
});

export function Registration() {
  const [loading, setLoading] = useState(false);
  const {saveAuth, setCurrentUser} = useAuth();
  const [visibleSuccess, setVisibleSuccess] = useState(false);
  const [subDomain, setSubDomain] = useState('');
  const intl = useIntl();

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true);

      try {
        const {data: res} = await register(
          values.id,
          values.name,
          values.adminEmail,
          values.userName,
          values.passWord,
          values.phoneNumber
        );
        setSubDomain(values.id);
        // saveAuth(auth);
        // const {data: user} = await getUserByToken(auth.token);
        // setCurrentUser(user);
        if (res == values.id) {
          setVisibleSuccess(true);
        } else {
          const errors = Object.values(res?.errors ?? {});
          let final_arr = [];
          errors.forEach((item) => {
            final_arr = _.concat(final_arr, item);
          });
          setStatus('Thất bại, vui lòng thử lại! \n' + final_arr.join('\n'));
        }
      } catch (error) {
        console.error(error);
        saveAuth(undefined);
        setStatus('Đăng ký không thành công!');
      }
      setSubmitting(false);
      setLoading(false);
    },
  });

  useEffect(() => {
    PasswordMeterComponent.bootstrap();
  }, []);
  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_signup_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='mb-5 text-center'>
          <h1 className='text-dark mb-3'>Đăng ký tài khoản</h1>
        </div>

        {formik.status && (
          <div className='mb-lg-5 alert alert-danger'>
            <div className='alert-text font-weight-bold' style={{whiteSpace: 'break-spaces'}}>
              {formik.status}
            </div>
          </div>
        )}

        {/* begin::Form group Firstname */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Họ tên</label>
          <input
            placeholder='Họ tên'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('name')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.name && formik.errors.name,
              },
              {
                'is-valid': formik.touched.name && !formik.errors.name,
              }
            )}
          />
          {formik.touched.name && formik.errors.name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.name}</span>
              </div>
            </div>
          )}
        </div>

        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Số điện thoại</label>
          <input
            placeholder='Số điện thoại'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('phoneNumber')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber,
              },
              {
                'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber,
              }
            )}
          />
          {formik.touched.phoneNumber && formik.errors.phoneNumber && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.phoneNumber}</span>
              </div>
            </div>
          )}
        </div>

        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Email</label>
          <input
            placeholder='Email'
            type='email'
            autoComplete='off'
            {...formik.getFieldProps('adminEmail')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.adminEmail && formik.errors.adminEmail},
              {
                'is-valid': formik.touched.adminEmail && !formik.errors.adminEmail,
              }
            )}
          />
          {formik.touched.adminEmail && formik.errors.adminEmail && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.adminEmail}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-5'>
          <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold'>
            <label className='form-label fw-bolder text-dark fs-6'>Tên miền </label>
            <label className='form-label fw-normal text-dark fs-6'>.smartparking.org</label>
          </div>
          <div className=''>
            <input
              placeholder='Tên miền'
              type='text'
              autoComplete='off'
              {...formik.getFieldProps('id')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.id && formik.errors.id,
                },
                {
                  'is-valid': formik.touched.id && !formik.errors.id,
                }
              )}
            />
          </div>

          {formik.touched.id && formik.errors.id && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.id}</span>
              </div>
            </div>
          )}
        </div>
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Tên đăng nhập</label>
          <input
            placeholder='Tên đăng nhập'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('userName')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.userName && formik.errors.userName},
              {
                'is-valid': formik.touched.userName && !formik.errors.userName,
              }
            )}
          />
          {formik.touched.userName && formik.errors.userName && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.userName}</span>
              </div>
            </div>
          )}
        </div>
        <div className='mb-5 fv-row' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6'>Mật khẩu</label>
            <div className='position-relative mb-3'>
              <input
                type='password'
                placeholder='Mật khẩu'
                autoComplete='off'
                {...formik.getFieldProps('passWord')}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {
                    'is-invalid': formik.touched.passWord && formik.errors.passWord,
                  },
                  {
                    'is-valid': formik.touched.passWord && !formik.errors.passWord,
                  }
                )}
              />
              {formik.touched.passWord && formik.errors.passWord && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.passWord}</span>
                  </div>
                </div>
              )}
            </div>
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
          </div>
          <div className='text-muted'>
            Từ 6-18 ký tự, gồm có: chữ hoa hoặc chữ thường và các ký tự đặc biệt
          </div>
        </div>
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>Xác nhận mật khẩu</label>
          <input
            type='password'
            placeholder='Xác nhận mật khẩu'
            autoComplete='off'
            {...formik.getFieldProps('changepassword')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
              },
              {
                'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
              }
            )}
          />
          {formik.touched.changepassword && formik.errors.changepassword && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.changepassword}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        {/* <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_toc_agree'
          >
            I Agree the{' '}
            <Link to='/auth/terms' className='ms-1 link-primary'>
              terms and conditions
            </Link>
            .
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div> */}
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center'>
          <button
            type='submit'
            id='kt_sign_up_submit'
            className='btn btn-lg btn-primary w-100 mb-5'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {!loading && <span className='indicator-label'>Đăng ký</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Đang xử lý...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <div class='text-gray-500 text-center fw-semibold fs-6'>
            {intl.formatMessage({id: 'LOGINPAGE.LOGINTITLE'})}
            <Link className='link-primary' to='/auth/login'>
              {intl.formatMessage({id: 'LOGINPAGE.LOGINBUTTON'})}
            </Link>
          </div>
          {/* <div className='text-gray-500 text-center fw-semibold fs-6'>
            Bạn đã có tài khoản?
            <a
              // href='/auth/login'
              className='link-primary fw-semibold ms-2'
              onClick={() => {
                setVisibleSuccess(true);
              }}
            >
              Đăng nhập
            </a>
          </div> */}
        </div>
        {/* end::Form group */}
      </form>
      <Modal
        show={visibleSuccess}
        //size={'lg'}
        backdrop='static'
        scrollable={false}
        onHide={() => {
          setVisibleSuccess(false);
        }}
      >
        <Modal.Body className='w-lg-600px bg-white rounded shadow-sm p-10'>
          <div className='d-flex flex-column flex-column-fluid text-center p-10'>
            <h1 className='fw-bolder fs-2qx text-success mb-5'>Đăng ký thành công</h1>
            <div className='fw-bold fs-3 text-muted mb-5'>
              Vui lòng đăng nhập để tiếp tục sử dụng.
            </div>
            <div className='mb-0'>
              <img src={toAbsoluteUrl('/media/auth/ok_w.png')} className='mw-100 mh-300px' alt='' />
            </div>

            <div className='text-center'>
              <a
                href={`http://${subDomain}.smartparking.vn/auth/login`}
                className='btn btn-lg btn-primary fw-bolder'
                onClick={() => {
                  setVisibleSuccess(false);
                }}
              >
                Đăng nhập
              </a>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
